// extracted by mini-css-extract-plugin
export default {"propertiesEmptyContainer":"styles_propertiesEmptyContainer__rbDXL","title":"styles_title__ijs1L","subtitle":"styles_subtitle__wqac8"};